<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">팀관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">팀 조회</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                팀 조회 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 80px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">부서명</th>
                  <td>{{ dataInfo.deptNm }}</td>
                </tr>
                <tr>
                  <th scope="row">팀 명</th>
                  <td>{{ dataInfo.teamNm }}</td>
                </tr>
                <tr>
                  <th scope="row">팀 설명</th>
                  <td>
                    <pre name="" id="">
                                            {{ dataInfo.teamDc }}
                                        </pre
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('teamlist')">목록</button>
          <button class="btn gray" @click="deleteConfirm">삭제</button>
          <button class="btn blue" @click="updateBtn(dataInfo)">수정</button>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg1 }}</p>
        <p>{{ msg2 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CloseBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import Alert from '../../../components/Alert01.vue';

export default {
  data() {
    return {
      showModalMsgSuccess: false,
      msg1: '선택하신 팀을 삭제하시겠습니까?',
      msg2: '삭제 시 관리자의 팀 정보를 모두 잃게 됩니다.',
      msg3: '정보를 변경 하시겠습니까?',

      dataId: '',
      dataInfo: {},
    };
  },

  components: {
    Alert,
  },

  mounted() {
    const dataId = this.$route.query.teamId;
    if (!dataId) {
      alert('잘못된 접근입니다.');
      this.$router.push('/teamlist');
    }
    this.dataId = dataId;
    this.findData();
  },

  methods: {
    CloseBtn() {
      this.showModalMsgSuccess = false;
    },

    async findData() {
      const res = await axios('get', '/api/team/view.json', {
        teamId: this.dataId,
      });
      this.dataInfo = res.data.resultVo;
    },

    updateBtn(teamObj) {
      const params = {
        deptId: teamObj.deptId,
        teamId: teamObj.teamId,
        teamNm: teamObj.teamNm,
        teamDc: teamObj.teamDc,
      };

      this.$router.push({
        name: 'teamupdate',
        params: { data: params },
      });
    },
    async deleteBtn() {
      let apiParams = new FormData();
      apiParams.append('teamId', this.dataId);
      await axios('post', '/api/team/delete.json', apiParams);
      await this.$router.push('teamlist');
    },

    deleteConfirm() {
      this.$confirm({
        message: '삭제하시겠습니까?',
        button: {
          no: '아니요',
          yes: '예',
        },
        callback: confirm => {
          if (confirm) {
            this.deleteBtn();
          }
        },
      });
    },
  },
};
</script>
